import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_SupervisionForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_SupervisionForm' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><center><h3>Supervision Form</h3></center></p>
                <p className='w-750'>This form (or equivalent) must be completed at least once during each supervisory period.</p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Supervisee:</span></td>
                        <td className='w-375'><span className='eleHeader'>Supervisor(s):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupervisee' name='txtSupervisee' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupervisor' name='txtSupervisor' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date</span></td>
                        <td className='w-375'><span className='eleHeader'>Time/Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='time' id='txtTimeDuration' name='txtTimeDuration' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Supervisory Meeting Format</span>
                            <span className='small'>(check all that apply) :</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbIndividual' name='cbIndividual' className='add-only' value='Individual' /> Individual
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGroup' name='cbGroup' className='add-only' value='Group' /> Group
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <b>This document covers the supervisory period from: &nbsp;</b>
                            <input type='date' id='txtSupervisoryPeriodDateFrom' name='txtSupervisoryPeriodDateFrom' className='add-only w-150 custom-add-only' />&nbsp; to &nbsp;
                            <input type='date' id='txtSupervisoryPeriodDateTo' name='txtSupervisoryPeriodDateTo' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Part I. Case Review</span></p>

                <p className='w-750'>
                    <input type='radio' id='rbNoCasePresented' name='rbCaseReview' className='add-only' value='NoCasePresented' /> No Case Presented
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbCasePresented' name='rbCaseReview' className='add-only' value='CasePresented' /> Case Presented: &nbsp;
                    <input type='text' id='txtCasePresented' name='txtCasePresented' className='add-only w-350 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes/Comments</span>
                    <textarea name='txtCaseReviewNotes' id='txtCaseReviewNotes' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Part II. Characteristics of Supervision Conducted During This Supervisory Period</span>
                    <span className='small'>(check all that apply; completed by supervisor)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCaseReview' name='cbCaseReview' className='add-only' value='CaseReview' /> Case Review
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDiagnosticSkills' name='cbDiagnosticSkills' className='add-only' value='DiagnosticSkills' /> Diagnostic Skills
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDischarging' name='cbDischarging' className='add-only' value='Discharging' /> Discharging
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInterventions' name='cbInterventions' className='add-only' value='Interventions' /> Interventions
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCareerGoals' name='cbCareerGoals' className='add-only' value='CareerGoals' /> Career goals
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSelfCare' name='cbSelfCare' className='add-only' value='SelfCare' /> Self-care
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTreatmentPlanning' name='cbTreatmentPlanning' className='add-only' value='TreatmentPlanning' /> Treatment planning
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCountertransference' name='cbCountertransference' className='add-only' value='Countertransference' /> Countertransference
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDevelopingConfidence' name='cbDevelopingConfidence' className='add-only' value='DevelopingConfidence' /> Developing confidence
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCulturalCompetence' name='cbCulturalCompetence' className='add-only' value='CulturalCompetence' /> Cultural competence
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDevelopingConfidence' name='cbDevelopingConfidence' className='add-only' value='DevelopingConfidence' /> Work-related stressors
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEthicalIssues' name='cbEthicalIssues' className='add-only' value='EthicalIssues' /> Ethical issues, including boundaries
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUseSelfClinicalWork' name='cbUseSelfClinicalWork' className='add-only' value='UseSelfClinicalWork' /> Use of self in clinical work
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWriteEffectiveNotes' name='cbWriteEffectiveNotes' className='add-only' value='WriteEffectiveNotes' /> How to write effective case notes
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRelationshipsWithColleagues' name='cbRelationshipsWithColleagues' className='add-only' value='RelationshipsWithColleagues' /> Relationships with colleagues and management
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCurrentEventsPolicies' name='cbCurrentEventsPolicies' className='add-only' value='CurrentEventsPolicies' /> Current events and policies related to social work
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLegalIssuesMandatedReporting' name='cbLegalIssuesMandatedReporting' className='add-only' value='LegalIssuesMandatedReporting' /> Legal issues, including things like mandated reporting
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>PART III. Evaluation of Supervisee Performance</span>
                    <span className='small'>(Completed by supervisor)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><b>S - </b> satisfactory</td>
                        <td className='w-187'><b>NI - </b> needs improvement</td>
                        <td className='w-187'><b>U - </b> unsatisfactory</td>
                        <td className='w-187'><b>N/A - </b> not applicable</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-50'><span className='eleHeader'>S</span></td>
                        <td className='w-50'><span className='eleHeader'>NI</span></td>
                        <td className='w-50'><span className='eleHeader'>U</span></td>
                        <td className='w-50'><span className='eleHeader'>N/A</span></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Maintains professional and courteous interactions with clients</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_1' name='txtS_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_1' name='txtNi_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_1' name='txtU_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_1' name='txtNa_1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Initiates professional self-improvement</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_2' name='txtS_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_2' name='txtNi_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_2' name='txtU_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_2' name='txtNa_2' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Accepts supervisory feedback appropriately</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_3' name='txtS_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_3' name='txtNi_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_3' name='txtU_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_3' name='txtNa_3' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Seeks supervision appropriately</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_4' name='txtS_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_4' name='txtNi_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_4' name='txtU_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_4' name='txtNa_4' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Timely submission of documentation</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_5' name='txtS_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_5' name='txtNi_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_5' name='txtU_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_5' name='txtNa_5' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Communicates effectively</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_6' name='txtS_6' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_6' name='txtNi_6' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_6' name='txtU_6' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_6' name='txtNa_6' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Demonstrates appropriate sensitivity to persons served</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_7' name='txtS_7' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_7' name='txtNi_7' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_7' name='txtU_7' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_7' name='txtNa_7' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Supervisee self-detects professional limitations</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_8' name='txtS_8' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_8' name='txtNi_8' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_8' name='txtU_8' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_8' name='txtNa_8' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>Acquisition of professional clinical skills</td>
                        <td className='w-50'>
                            <input type='text' id='txtS_9' name='txtS_9' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNi_9' name='txtNi_9' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtU_9' name='txtU_9' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtNa_9' name='txtNa_9' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>
                            <b>Overall evaluation of supervisee performance during this period (circle one):</b>
                        </td>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-50'>
                            <input type='radio' id='rbOverallEvaluation_S' name='rbOverallEvaluation' className='add-only' value='OverallEvaluation_S' /> <b> S </b>
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOverallEvaluation_Ni' name='rbOverallEvaluation' className='add-only' value='OverallEvaluation_Ni' /> <b> NI </b>
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOverallEvaluation_U' name='rbOverallEvaluation' className='add-only' value='OverallEvaluation_U' /> <b> U </b>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Notes/Comments:</span>
                    <textarea name='txtOverallEvaluationComments' id='txtOverallEvaluationComments' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-360'></td>
                        <td className='signature w-360'></td>
                    </tr>
                    <tr>
                        <td className='small w-360'>Supervisee signature:</td>
                        <td className='small w-360'>Date:</td>
                    </tr>
                    
                    <tr>
                        <td className='signature w-360'></td>
                        <td className='signature w-360'></td>
                    </tr>
                    <tr>
                        <td className='small w-360'>Supervisee signature:</td>
                        <td className='small w-360'>Date:</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}